var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChemistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2661a1a9dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.4375 37.5 L 312.9375 37.5 L 312.9375 337.5 L 62.4375 337.5 Z M 62.4375 37.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2661a1a9dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#585b9a",
    d: "M 306.113281 271.03125 L 224.96875 137.492188 L 224.96875 73.9375 C 232.25 71.355469 237.46875 64.417969 237.46875 56.25 C 237.46875 45.90625 229.070312 37.5 218.71875 37.5 L 156.222656 37.5 C 145.867188 37.5 137.472656 45.90625 137.472656 56.25 C 137.472656 64.417969 142.691406 71.355469 149.96875 73.9375 L 149.96875 137.496094 L 68.828125 271.03125 C 64.789062 277.660156 62.472656 285.425781 62.472656 293.753906 C 62.472656 317.90625 82.058594 337.5 106.21875 337.5 L 268.722656 337.5 C 292.882812 337.5 312.46875 317.90625 312.46875 293.753906 C 312.46875 285.425781 310.152344 277.660156 306.113281 271.03125 Z M 156.222656 50.007812 L 218.71875 50.007812 C 222.167969 50.007812 224.96875 52.808594 224.96875 56.25 C 224.96875 59.691406 222.167969 62.492188 218.71875 62.492188 L 156.222656 62.492188 C 152.773438 62.492188 149.96875 59.691406 149.96875 56.25 C 149.96875 52.808594 152.773438 50.007812 156.222656 50.007812 Z M 160.65625 143.992188 L 162.46875 141.007812 L 162.46875 75 L 212.472656 75 L 212.472656 141.007812 L 214.285156 143.992188 L 267.71875 231.902344 C 263.605469 236.222656 258.9375 240.214844 253.738281 243.730469 C 243.0625 250.964844 232.652344 254.734375 222.378906 255.816406 C 199.65625 258.214844 177.621094 247.375 154.804688 231.425781 C 143.582031 223.570312 131.605469 216.597656 119.210938 212.183594 Z M 160.65625 143.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistry);
export default __webpack_public_path__ + "static/media/chemistry.a8afcdee1d4cc12db628f8303ef2a988.svg";
export { ForwardRef as ReactComponent };